import { BottomAxis } from "./BottomAxis";
export default BottomAxis;
